module.exports = __webpack_public_path__ + "static/media/logo.36e0c02d.png";